import { DataItem, SectionHeader } from 'components';
import { capitalize } from 'lodash';
import { GameServer, ServerType } from 'models';
import React from 'react';

import LeaderboardModal from './LeaderboardModal';

export interface GameServerCardProps {
  selectedGameServer: GameServer;
  isSelectedGameServerFinished: boolean;
  onLogout: () => void;
}

export const GameServerCard: React.FC<GameServerCardProps> = ({
  selectedGameServer,
  isSelectedGameServerFinished,
  onLogout,
}) => {
  const isClickerAppServer = selectedGameServer?.type === ServerType.ClickerApp;

  return (
    <div className="section-container game-server">
      <SectionHeader
        title={'Game server'}
        description={'Below are displayed basic game server details'}
      />

      <div className="game-server-data-items">
        <DataItem
          iconClasses={'fa fa-server'}
          label={'Server name'}
          data={selectedGameServer.name}
        />

        {!isClickerAppServer &&
          (isSelectedGameServerFinished ? (
            <DataItem
              iconClasses="fa fa-info"
              label="Status"
              data={capitalize(selectedGameServer.status)}
            />
          ) : (
            <DataItem
              iconClasses="fa fa-users"
              label="Players"
              data={`${selectedGameServer.stats.players} / ${selectedGameServer.players_limit}`}
            />
          ))}
      </div>

      {!isClickerAppServer && (
        <LeaderboardModal
          serverAddress={`${selectedGameServer.address}/server/mainLdb`}
        />
      )}

      <button
        className="btn btn-secondary nowrap mt-32 w-100"
        onClick={(): void => onLogout()}
      >
        <i className="fa fa-power-off pointer mr-8" />
        Logout
      </button>
    </div>
  );
};
